(() => {
  const initialize = scope => {
    const roots = [...scope.querySelectorAll('[data-size-guide]')];
    if (scope.matches?.('[data-size-guide]')) roots.unshift(scope);
    roots.forEach(root => {
      if (root.dataset.sizeReady) return;
      const units = [...root.querySelectorAll('[data-size-unit]')];
      const controls = root.querySelector('[data-size-controls]');
      const status = root.querySelector('[data-size-status]');
      if (!units.length || !controls) return;
      units.forEach(button => button.addEventListener('click', () => {
        const unit = button.dataset.sizeUnit;
        if (unit !== 'cm' && unit !== 'in') return;
        root.querySelectorAll('[data-size-cm]').forEach(cell => {
          cell.textContent = unit === 'cm' ? cell.dataset.sizeCm : cell.dataset.sizeIn;
        });
        root.querySelectorAll('[data-size-unit-label]').forEach(label => { label.textContent = unit; });
        units.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.sizeUnit === unit)));
        if (status) status.textContent = 'All size charts now show measurements in ' + (unit === 'cm' ? 'centimeters.' : 'inches.');
      }));
      root.dataset.sizeReady = 'true';
      controls.hidden = false;
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
